<template>
  <div class="request-show-header container">
    <div class="header-row columns">
      <div class="column is-4-desktop is-full-tablet header-left">
        <div v-if="$slots.cycling" class="header-item">
          <slot name="cycling" />
        </div>
        <div class="header-item is-size-3">
          <slot name="id" />
        </div>
        <div class="header-item header-banner">
          <slot name="banner" />
        </div>
      </div>

      <div class="column is-8-desktop is-full-tablet header-right">
        <div v-if="$slots.invoiceNotice" class="invoice-container">
          <div class="invoice-notice">
            <slot name="invoiceNotice" />
          </div>
        </div>
        <div class="block icon-tray">
          <slot name="icons" />
        </div>
      </div>
    </div>

    <div v-if="$slots.filters" class="header-row columns">
      <div class="column is-4-desktop">
        <slot name="filters" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.header-row {
  flex-wrap: wrap;
}

.invoice-container {
  flex: 1;
}

.request-show-header {
  padding-top: 1.5rem;
}

.request-show-header .column {
  padding: 0 0.75rem;
}

.header-item {
  margin-right: 1rem;
}

.header-banner {
  /* HACK: Fixes the NrBanner component rendering too far to the left */
  margin-left: 1em;
}

.invoice-notice {
  background-color: #f4f4f6;
  border-radius: 4px;

  margin-right: 0.5em;
}

.header-left {
  display: flex;
  text-wrap: nowrap;
  flex-wrap: wrap;
  align-items: center;
}

.header-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
